import { render } from "./ContactGroups.vue?vue&type=template&id=948277b4"
import script from "./ContactGroups.vue?vue&type=script&lang=js"
export * from "./ContactGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__